<ng-container *ngIf="flags.length; else noResolvedFlags">
    <table mat-table class="resolved-flags-table" [dataSource]="flags">
        <ng-container matColumnDef="category">
            <th *matHeaderCellDef mat-header-cell scope="col">Category</th>
            <td *matCellDef="let element" mat-cell>
                <span class="resolved-flags-table__category">
                    <svg aria-hidden="true" fill="none" viewBox="0 0 15 15">
                        <path
                            d="M0.0195312 11.8799V0.819336H9.33011L7.34926 3.95738L9.33011 7.08711H1.4487V11.8799H0.0195312Z"
                            [attr.fill]="element?.categoryColor"
                        />
                    </svg>
                    {{ element.category | uppercase }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
            <th *matHeaderCellDef mat-header-cell scope="col">Created by</th>
            <td *matCellDef="let element" mat-cell>
                <div class="resolved-flags-table__person">
                    <span class="resolved-flags-table__person-name">{{ element.createdBy }}</span>
                    <span>{{ element.createdOn | date: 'HH:mm' }} {{ element.timezone }}</span>
                    <span>{{ element.createdOn | date: 'MM/dd/yyyy' }}</span>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="resolvedBy">
            <th *matHeaderCellDef mat-header-cell scope="col">Resolved by</th>
            <td *matCellDef="let element" mat-cell>
                <div class="resolved-flags-table__person">
                    <span class="resolved-flags-table__person-name">{{ element.resolvedBy }}</span>
                    <span>{{ element.resolvedOn | date: 'HH:mm' }} {{ element.timezone }}</span>
                    <span>{{ element.resolvedOn | date: 'MM/dd/yyyy' }}</span>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="reason">
            <th *matHeaderCellDef mat-header-cell scope="col">Description</th>
            <td *matCellDef="let element" mat-cell>
                <span class="resolved-flags-table__clamp" [title]="element.reason">{{ element.reason }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="resolutionNote">
            <th *matHeaderCellDef mat-header-cell scope="col">Resolution</th>
            <td *matCellDef="let element" mat-cell>
                <span class="resolved-flags-table__clamp" [title]="element.resolutionNote">{{ element.resolutionNote }}</span>
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
</ng-container>

<ng-template #noResolvedFlags>
    <div class="resolved-flags-table__empty">
        <ds-icon name="task_alt" size="lg" theme="tertiary"></ds-icon>
        <ds-text size="sm" theme="secondary" text="No resolved flags yet. A flag moves here when you resolve it."></ds-text>
    </div>
</ng-template>
